import React, { useState, useEffect } from "react"
import { v4 as uuidv4 } from 'uuid';

import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel
} from "@reach/accordion"
import "@reach/accordion/styles.css"

function LandingAccordionColours({  landingAccordionColoursAccordionGroup }){
    return (
        <section className="landing-accordion-colours section-spacing-lg bg-white"> 
            <div className="content-block">
                {landingAccordionColoursAccordionGroup && Boolean(landingAccordionColoursAccordionGroup.length > 0) &&
                    <Accordion collapsible={true} multiple={true}>
                        <div className="landing-accordion-colors__wrapper">
                            {landingAccordionColoursAccordionGroup.map((group, index) => {
                                return (
                                    <AccordionItem className="landing-accordion-colors-item__wrapper" key={uuidv4()}>
                                        {group.landingAccordionColoursAccordionGroupTitle &&                   
                                            <AccordionButton className="landing_accordion_colours_accordion__button">
                                                <h3>
                                                    <span className="lp-heading-lg landing_accordion_colours_accordion_group_title ">
                                                        {group.landingAccordionColoursAccordionGroupTitle} 
                                                    </span>                        
                                                </h3>
                                            </AccordionButton>
                                        }
                                        {group.landingAccordionColoursAccordionGroupText &&
                                            <AccordionPanel className="landing_accordion_colours_accordion_group_text lp-body-lg">
                                                <div className="landing_accordion_colours_accordion_group_text__inner"
                                                    dangerouslySetInnerHTML={{ __html: group.landingAccordionColoursAccordionGroupText }}>
                                                </div>                                                
                                            </AccordionPanel>                                          
                                        }
                                    </AccordionItem>
                                )
                            })}
                        </div>
                    </Accordion>
                }            
            </div>
        </section>
    )
}


export default LandingAccordionColours
